import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import swal from "sweetalert";

function HistoryBet() {
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);

    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return d.getFullYear() + "/" + 
               ("0" + (d.getMonth() + 1)).slice(-2) + "/" + 
               ("0" + d.getDate()).slice(-2) + "  " + 
               ("0" + d.getHours()).slice(-2) + ":" + 
               ("0" + d.getMinutes()).slice(-2);
    }

    const [history, setHistory] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/history/historyus`, {})
            .then((res) => {
                setHistory(res.data.data);
            })
            .catch((err) => console.log(err));
        
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    const XSMN = ["Bạc Liêu", "Vũng Tàu", "Tiền Giang", "Kiên Giang", "Đà Lạt", "Bình Phước", "Bình Dương", "An Giang", "Bình Thuận", "Cà Mau", "Cần Thơ", "Hậu Giang", "Đồng Tháp", "Tây Ninh", "Vĩnh Long", "Trà Vinh", "Sóc Trăng", "Long An", "TP. HCM", "Đồng Nai", "Bến Tre"];
    const XSMT = ["Đà Nẵng", "Thừa T. Huế", "Quảng Trị", "Phú Yên", "Quảng Bình", "Quảng Nam", "Quảng Ngãi", "Ninh Thuận", "Kon Tum", "Khánh Hòa", "Gia Lai", "Bình Định", "Đắk Lắk", "Đắk Nông"];

    const checkCancel = (item) => {
        if (!item || !item.id_bet) return 1;
        const currentDate = new Date();
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        const formattedDate = `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`;
        const minute = currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes();
        const currentTimeInt = Number(currentDate.getHours() + "" + minute);

        if (item.sanh === "XSMB" && item.id_bet == formattedDate && currentTimeInt >= 1800) return 0;
        else if (XSMT.includes(item.sanh) && item.id_bet == formattedDate && currentTimeInt >= 1700) return 0;
        else if (XSMN.includes(item.sanh) && item.id_bet == formattedDate && currentTimeInt >= 1600) return 0;
        else return 1;
    };

    // ==========================================
    // 🔥 BÊ NGUYÊN BỘ DỊCH formatHistoryData TỪ BẢN PC SANG 🔥
    const formatHistoryData = (item) => {
        if (!item) return { displaySanh: "", displayState: "" };

        let sanhName = String(item.sanh || "");
        let stateVal = String(item.state || "");
        let typeCode = String(item.type || "").toUpperCase(); // VD: "XD45S", "TX60S"
        let gameName = String(item.game || ""); // VD: "Xóc đĩa 45s"

        let displaySanh = sanhName;
        let displayState = stateVal;

        // 1. Nếu là Xổ Số hoặc Bầu Cua thì bỏ qua không dịch
        if (XSMN.includes(sanhName) || XSMT.includes(sanhName) || sanhName === "XSMB" || sanhName.includes("Xổ số") || sanhName.includes("XS")) {
            return { displaySanh: sanhName === "XSMB" ? "Miền Bắc" : sanhName, displayState: stateVal };
        }
        if (sanhName.includes("CatDog") || typeCode.includes("CATDOG") || typeCode === "7") {
            return { displaySanh: "Bầu Cua / CatDog", displayState: stateVal };
        }

        // 2. Xác định Game dựa trên thông số rõ ràng từ Database
        let isXD = typeCode.includes("XD") || gameName.toLowerCase().includes("xóc đĩa");
        let isTX = typeCode.includes("TX") || gameName.toLowerCase().includes("tài xỉu");

        // 3. Chuẩn hóa Tên Sảnh
        let sanhNum = sanhName.replace(/[^0-9]/g, '');
        if (!sanhNum) sanhNum = "1";
        if (sanhNum.length > 1) sanhNum = sanhNum.replace('45', '').replace('60', '').replace('75', '').replace('120', '') || "1";

        if (gameName) {
            displaySanh = `${gameName} (Sảnh ${sanhNum})`;
        } else if (isXD) {
            displaySanh = `Xóc đĩa (Sảnh ${sanhNum})`;
        } else if (isTX) {
            displaySanh = `Tài xỉu (Sảnh ${sanhNum})`;
        } else {
            // Backup cho các ván cược cũ
            if (stateVal.includes("5") || stateVal.includes("6") || stateVal.includes("00") || stateVal.includes("11")) {
                isXD = true;
                displaySanh = `Xóc đĩa (Sảnh ${sanhNum})`;
            } else {
                isTX = true;
                displaySanh = `Tài xỉu (Sảnh ${sanhNum})`;
            }
        }

        // Tài Xỉu MD5 đặc biệt
        if (sanhName.toUpperCase().includes("MD5") || typeCode.includes("MD5")) {
            displaySanh = "Tài xỉu MD5 60s";
            isTX = true;
            isXD = false;
        }

        // 4. Dịch lựa chọn của khách hàng
        const parts = stateVal.split(" ");
        const translated = parts.map(val => {
            if (isXD) {
                if (val === "1" || val === "1111") return "4 Đỏ";
                if (val === "2" || val === "0000") return "4 Trắng";
                if (val === "3" || val === "1110") return "3 Đỏ 1 Trắng";
                if (val === "4" || val === "0001") return "3 Trắng 1 Đỏ";
                if (val === "5" || val === "0011") return "Chẵn";
                if (val === "6" || val === "0111") return "Lẻ";
            } else if (isTX) {
                if (val === "1") return "Chẵn";
                if (val === "2") return "Lẻ";
                if (val === "3") return "Tài";
                if (val === "4") return "Xỉu";
            }
            return val;
        });

        displayState = translated.join(", ");

        return { displaySanh, displayState };
    };
    // ==========================================

    return (
        <>
            <div className="title-top">
                <div className="back" onClick={handleBackClick}>
                    <KeyboardArrowLeftOutlinedIcon />
                </div>
                <h1 className="title-h1">Lịch sử trò chơi</h1>
            </div>
            <div className="main">
                {history != null ? (
                    <div className="content-history" style={{ margin: "0.2rem 0 0" }}>
                        <AnimatedPage>
                            {history?.map((item, key) => {
                                // 🔥 GỌI HÀM DỊCH ĐÃ CHUẨN HÓA 🔥
                                const { displaySanh, displayState } = formatHistoryData(item);
                                
                                return (
                                    <div key={key}>
                                        <div
                                            className="item_inner"
                                            onClick={() => {
                                                setLs(item);
                                                setShow(true);
                                            }}>
                                            <div className="item_history">
                                                <div className="title_item_history" style={{ display: 'flex', alignItems: 'center' }}>
                                                    {/* Hiển thị tên Sảnh chuẩn */}
                                                    <span className="sanh" style={{ marginRight: '8px' }}>{displaySanh}</span>
                                                    
                                                    {/* TEM THẮNG/THUA */}
                                                    <span
                                                        className={`badge-status ${
                                                            item?.status_bet === "Pending"
                                                                ? "pending"
                                                                : item?.status_bet === "Win"
                                                                ? "win"
                                                                : item?.status_bet === "Lose"
                                                                ? "lose"
                                                                : "cancelled"
                                                        }`}>
                                                        {item?.status_bet === "Pending"
                                                            ? "Chờ xổ"
                                                            : item?.status_bet === "Win"
                                                            ? "Thắng"
                                                            : item?.status_bet === "Lose"
                                                            ? "Thua"
                                                            : "Đã hủy"}
                                                    </span>
                                                    
                                                    {/* Nút Hủy Cược (Cho XSMB, XSMN, XSMT) */}
                                                    {item?.status_bet === "Pending" && (
                                                        <>
                                                            {(item?.sanh === "XSMB" || XSMN.includes(item?.sanh) || XSMT.includes(item?.sanh)) && (
                                                                <>
                                                                    {checkCancel(item) === 1 && (
                                                                        <span
                                                                            className="cancel-bet type_state"
                                                                            style={{ marginLeft: '10px' }}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.target.style.display = "none";
                                                                                axios
                                                                                    .patch(`${process.env.REACT_APP_API_URL}/history/cancel`, {
                                                                                        id: item?._id,
                                                                                        userId: profile?._id,
                                                                                        money: item?.money
                                                                                    })
                                                                                    .then((res) => {
                                                                                        setShow(false);
                                                                                        swal("Hủy cược thành công", "", "success").then((value) => {
                                                                                            axios
                                                                                                .get(`${process.env.REACT_APP_API_URL}/history/historyus`, {})
                                                                                                .then((res) => {
                                                                                                    setHistory(res.data.data);
                                                                                                })
                                                                                                .catch((err) => {});
                                                                                        });
                                                                                    })
                                                                                    .catch((err) => {
                                                                                        setShow(false);
                                                                                        swal("Thông báo", "Đã xảy ra lỗi, vui lòng thử lại!", "error");
                                                                                        e.target.style.display = "inline-block";
                                                                                    });
                                                                            }}>
                                                                            &times; Hủy cược
                                                                        </span>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                <div className="id_history_sanh">Phiên cược: {item?.id_bet?.id_bet ? item?.id_bet?.id_bet : item?.id_bet}</div>
                                                
                                                {/* 🔥 HIỂN THỊ TÊN CỬA CHỌN (ĐÃ DỊCH) 🔥 */}
                                                <div className="id_history_sanh" style={{ fontWeight: 'bold', color: '#ffc107' }}>
                                                    Cửa: {displayState}
                                                </div>
                                            </div>
                                            <div className="money_history">
                                                <span className="money">{Number(item?.money).toLocaleString("vi-VN")}₫</span>
                                                <div className="time_choose">{formatDate(new Date(item?.createdAt))}</div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </AnimatedPage>
                    </div>
                ) : null}

                <Footer profile={profile} />

                {isShow === true && ls?.status_bet !== "Pending" ? (
                    <>
                        <div className="modal" style={{ zIndex: "9999999" }}>
                            <div className="modaloverlay" onClick={() => setShow(false)}>
                                <i className="ti-close closelogin"></i>
                            </div>
                            <div className="modalbody">
                                <div>
                                    <div className="modalinner" style={{ padding: "10px 15px" }}>
                                        <div className="modalheader" style={{ padding: "10px 0 20px" }}>
                                            Chi tiết cược
                                        </div>

                                        {ls?.id_bet?.id_bet || ls?.id_bet ? (
                                            <>
                                                {/* Gọi lại hàm dịch cho Modal chi tiết */}
                                                {(() => {
                                                    const { displaySanh, displayState } = formatHistoryData(ls);
                                                    return (
                                                        <>
                                                            <div className="lsgd-table">
                                                                <div>Trò chơi</div>
                                                                <div>{displaySanh}</div>
                                                            </div>
                                                            <div className="lsgd-table">
                                                                <div>Phiên</div>
                                                                <div>{ls?.id_bet?.id_bet ? ls?.id_bet?.id_bet : ls?.id_bet ? ls?.id_bet : "Không xác định"}</div>
                                                            </div>
                                                            <div className="lsgd-table">
                                                                <div>Thời gian</div>
                                                                <div>{formatDate(new Date(ls?.createdAt))}</div>
                                                            </div>
                                                            <div className="lsgd-table">
                                                                <div>Đặt cược</div>
                                                                <div style={{ color: "#dc3545", fontWeight: "bold" }}>
                                                                    {displayState}
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                })()}
                                                
                                                <div className="lsgd-table">
                                                    <div>Tổng Cược</div>
                                                    <div>{Number(ls?.money).toLocaleString("vi-VN")} ₫</div>
                                                </div>
                                                <div className="lsgd-table">
                                                    <div>Tổng thắng</div>
                                                    <div style={{ color: "#28a745", fontWeight: "bold" }}>{Number(ls?.moneythang).toLocaleString("vi-VN")} ₫</div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div>
                                            <div className="modalformcontrols">
                                                <button
                                                    onClick={() => setShow(false)}
                                                    className="popup-close"
                                                    style={{
                                                        background: "#0064ff",
                                                        boxShadow: "none",
                                                        textShadow: "none",
                                                        width: "100%",
                                                        marginTop: "20px",
                                                        padding: "10px",
                                                        color: "#fff",
                                                        borderRadius: "5px",
                                                        border: "none"
                                                    }}>
                                                    ĐÓNG
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : null}

                {/* 🔥 STYLE CHO CÁC TEM BADGE THẮNG/THUA 🔥 */}
                <style>{`
                    .badge-status {
                        padding: 3px 8px;
                        border-radius: 4px;
                        font-size: 11px;
                        color: #fff;
                        font-weight: bold;
                    }
                    .badge-status.win { background-color: #28a745; }
                    .badge-status.lose { background-color: #dc3545; }
                    .badge-status.pending { background-color: #ffc107; color: #000; }
                    .badge-status.cancelled { background-color: #6c757d; }
                `}</style>
            </div>
        </>
    );
}
export default HistoryBet;